import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetProjectAccountRequest,
  GetProjectAccountResponse,
} from "../../models/ProjectAccount.model";

const API_URL = environment.apiUrl;

export const getProjectAccount = createAsyncThunk<
  GetProjectAccountResponse,
  GetProjectAccountRequest,
  { rejectValue: string }
>(
  "projectAccount/getProjectAccount",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_URL}ProjectAccount/GetProjectAccount`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetProjectAccountResponse = await response.json();

      if (!data.succeeded)
        return rejectWithValue(
          data.massage || "Failed to fetch project account"
        );
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);
